// There is an On-Road Traction attribute, but its value has no effect.
// https://www.mariowiki.com/Mario_Kart_8_Deluxe_in-game_statistics#On-Road_Traction_.28ON.29
export const STATISTICS = [
  {
    name: 'Speed, Ground',
    help: {
      topic: 'Speed',
      description: 'A higher value gives you a higher top speed. Your top speed also increases as you collect coins.'
    }
  },
  {
    name: 'Speed, Water'
  },
  {
    name: 'Speed, Air'
  },
  {
    name: 'Speed, Anti-Gravity'
  },
  {
    name: 'Acceleration',
    help: {
      topic: 'Acceleration',
      description: 'A higher value means you reach your top speed faster.'
    }
  },
  {
    name: 'Weight',
    help: {
      topic: 'Weight',
      description: 'A higher value makes you more stable when you bump into other racers. Heavier vehicles can knock away lighter vehicles.'
    }
  },
  {
    name: 'Handling, Ground',
    help: {
      topic: 'Handling',
      description: 'A higher value means you can turn sharper and can adjust direction more while drifting or gliding.'
    }
  },
  {
    name: 'Handling, Water'
  },
  {
    name: 'Handling, Air'
  },
  {
    name: 'Handling, Anti-Gravity'
  },
  {
    name: 'Traction',
    help: {
      topic: 'Traction',
      description: 'A higher value means you slip less and lose less speed on sand and ice. Slips and slowdowns on dirt are not affected by this score.'
    }
  },
  {
    name: 'Mini-Turbo',
    help: {
      topic: 'Mini-Turbo',
      description: 'A higher value means you charge boosts faster, gain more relative speed, and boost for longer. This includes drift and jump boosts.'
    }
  },
  {
    name: 'Invincibility',
    help: {
      topic: 'Invincibility',
      description: 'A higher value means you are invincible for longer after a spin-out or crash.'
    }
  }
];

export const STAT_INDEXES = {};

STATISTICS.forEach((stat, index) => {
  stat.index = index;
  STAT_INDEXES[stat.name] = index;
});
